import { formatDate, getDateFormatForDatePicket } from "helper/dateFormat";
const countKeysWithName = (data, label) => {
  let count = 0;
  for (let key in data) {
    if (key.includes(label)) {
      count++;
    }
  }
  return count;
}

export const getFormDataHandler = (formData,values, parentLabel = "") => {
  if(!formData || !Array.isArray(formData) || !values || !Array.isArray(values)) return {};
  let fields = {};
  const result = formData?.forEach((form) => {
    const findCurrentValue = values?.find((val) => val?.id === form?.id);
    if(findCurrentValue && findCurrentValue?.value !== undefined && findCurrentValue?.value !== null && form?.label) {
      const keyCount =  countKeysWithName(fields, form.label.trim())
      let label = form?.label.trim();
      if(keyCount) {
        label = `${form?.label.trim()}_${keyCount}`
      }
      
      // Add parent label prefix if provided
      if(parentLabel) {
        label = `${parentLabel} ${label}`;
      }
      
      const checkBoxesOption = form?.element === "RadioButtons" || form?.element === "Checkboxes";
      if (checkBoxesOption && Array.isArray(findCurrentValue?.value)) {
        const optionKeys = new Set((form?.options || []).map((option) => option?.key));
        const checkboxesValues = findCurrentValue?.value?.map((value) => {
          let filteredValue = value;
          if (!optionKeys.has(value)) {
            const lastIndexOfUnderLine = value?.lastIndexOf("_");
            filteredValue = value.substring(0, lastIndexOfUnderLine);
          }
          const option = form?.options?.find((option) => option?.key === filteredValue)
          return option?.text;
        }).filter(Boolean);
        fields[label] = checkboxesValues?.join(", ");
      } else if (form?.element === "DatePicker") {
        fields[label] = findCurrentValue.value  ? formatDate({date:findCurrentValue.value, formatType: "default"}) : "";
      } else {
        fields[label] = findCurrentValue.value;
      }
    }
    return;
  });
  return fields;
};



export const formatDateInFormData = (formData) => {
  if(!formData || !formData?.length) return [];
  const dateFormat = getDateFormatForDatePicket();
  const data = formData?.map((form) => {
    if(form?.element === "DatePicker") {
      return {
        ...form,
        dateFormat: dateFormat,
      }
    }
    return form;
  });
  return data;
}
export const displayProductsHandler = (products) => {
  if(!products?.length) return {};
  let productsData = {};
  const data = products?.map((product) => {
    if(product?.quantity) {
      productsData[product.title] = product?.quantity
    }
    if(product?.variant && Object.keys(product?.variant)?.length) {
      const variantsData = Object.entries(product?.variant).map(([key, value]) => {
        productsData[`${product.title}-${key}`] = value
      })
    }
  })
  return productsData;
}

export const sanitizeItems = (items) => {
  const validIds = new Set(items.map(i => i.id));
  return items.map(item => {
    if (item.childItems) {
      return {
        ...item,
        childItems: item.childItems.filter(childId => validIds.has(childId))
      };
    }
    return item;
  });
};